export default __webpack_public_path__ + "static/media/premios.41569289.png";